import React, { useState } from 'react';

import { Box, Button } from '@rbilabs/universal-components';
import AsyncStorage from '@react-native-async-storage/async-storage';

import useEffectOnce from 'hooks/use-effect-once';
import { EnvListContainer, HiddenEnvItem, HiddenSection } from 'pages/diagnostics/components';
import { clearLocaleStorage } from 'utils/intl/locale/clear-locale-storage';
import LocalStorage from 'utils/local-storage';

const LocalStorageItemsContent = () => {
  const [localStorageData, setLocalStorageData] = useState({});

  useEffectOnce(() => {
    LocalStorage.getAll()
      .then(data => {
        setLocalStorageData(data);
      })
      .catch(() => {
        alert('failed to get local storage data');
      });
  });
  return (
    <>
      <Button onPress={clearLocaleStorage}>Clear Has Shown Locale Selector Storage</Button>
      <EnvListContainer>
        {Object.entries(localStorageData).map(([key, value]) => (
          <Box>
            <HiddenEnvItem key={key} envKey={key} value={JSON.stringify(value)} />
            <Button onPress={() => AsyncStorage.removeItem(key)}>Remove</Button>
          </Box>
        ))}
      </EnvListContainer>
    </>
  );
};

export const LocalStorageItems = () => (
  <HiddenSection title="Local Storage Items" content={<LocalStorageItemsContent />} />
);
